module.exports = __webpack_public_path__ + "static/media/robofriends.32fe0ce8.png";